import React from 'react'

import getGroupHraBenefitDesignState from 'core/application/adminDashboard/benefitDetails/groupHra/benefitDesignState'
import getGroupHraDesignBenefitWizard from 'core/application/adminDashboard/benefitDetails/groupHra/benefitDesignWizard'

import DesignBenefitWizard from '../common/DesignBenefitWizard'
import { NavItemsMapping, ReadonlyStepsWhenBenefitIsFinished } from './DesignStepsMapping'

const GroupDesignBenefit: React.FC = (props) => {
  return (
    <DesignBenefitWizard
      getBenefitDesignWizard={(planPeriodId) => getGroupHraDesignBenefitWizard(planPeriodId)}
      getBenefitDesignWizardState={(planPeriodId) => getGroupHraBenefitDesignState(planPeriodId)}
      navItemsMapping={NavItemsMapping}
      readonlyStepsWhenBenefitIsFinished={ReadonlyStepsWhenBenefitIsFinished}
    />
  )
}

export default GroupDesignBenefit
